export function toSortedCompat<T>(
  items: readonly T[],
  compareFn?: (a: T, b: T) => number,
): T[] {
  if (typeof items.toSorted === "function") {
    return items.toSorted(compareFn);
  }
  return [...items].sort(compareFn);
}
